import React from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'

import { SELECTOR_STYLE } from '@common'

const Selector = ({
    value,
    defaultValue,
    options,
    isDisabled = false,
    isLoading = false,
    isClearable = false,
    isSearchable = false,
    textHeader,
    textPlaceholder,
    onChange,
    containerClassName,
}) => {
    return (
        <div className={containerClassName}>
            {textHeader && <h6>{textHeader}</h6>}
            <Select
                value={value}
                defaultValue={defaultValue}
                placeholder={textPlaceholder}
                options={options}
                onChange={onChange}
                isDisabled={isDisabled}
                isLoading={isLoading}
                isClearable={isClearable}
                isSearchable={isSearchable}
                styles={SELECTOR_STYLE}
            />
        </div>
    )
}

Selector.propTypes = {
    value: PropTypes.any,
    defaultValue: PropTypes.any,
    options: PropTypes.array.isRequired,
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    isClearable: PropTypes.bool,
    isSearchable: PropTypes.bool,
    textHeader: PropTypes.string,
    textPlaceholder: PropTypes.string,
    onChange: PropTypes.func,
    containerClassName: PropTypes.string,
}

export default Selector
